module.exports = __webpack_public_path__ + "static/media/erreur.8d4d3fc4.svg";